import { render, staticRenderFns } from "./StepAssessmentName.vue?vue&type=template&id=753ea3d9&scoped=true&"
import script from "./StepAssessmentName.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StepAssessmentName.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StepAssessmentName.vue?vue&type=style&index=0&id=753ea3d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ea3d9",
  null
  
)

export default component.exports